const data = {
  'Selected': 'Выбрано: {0} из {1}',
  'Uploading files': 'Загрузка {0}% of {1}',
  'File size error': '{0} слишком большой, пожалуйста, загрузите файл меньше {1}',
  'Upload failed': '{0} не удалось загрузить',
  'Per page': '{0} На страницу',
  'Folder': 'Папка',
  'Login failed, please try again': 'Вход не выполнен. Пожалуйста попробуйте еще раз',
  'Already logged in': 'Уже авторизован.',
  'Please enter username and password': 'Пожалуйста, введите имя пользователя и пароль.',
  'Not Found': 'Не найдено',
  'Not Allowed': 'Не разрешено',
  'Please log in': 'Пожалуйста, войдите',
  'Unknown error': 'Неизвестная ошибка',
  'Add files': 'Добавить файлы',
  'New': 'Создать',
  'New name': 'Новое имя',
  'Username': 'Имя пользователя',
  'Password': 'Пароль',
  'Login': 'Вход',
  'Logout': 'Выход',
  'Profile': 'Профиль',
  'No pagination': 'Без разбивки на страницы',
  'Time': 'Время',
  'Name': 'Имя',
  'Size': 'Размер',
  'Home': 'Главная',
  'Copy': 'Копировать',
  'Move': 'Переместить',
  'Rename': 'Переименовать',
  'Required': 'Пожалуйста, заполните это поле',
  'Zip': 'Архивировать zip',
  'Batch Download': 'Пакетная загрузка',
  'Unzip': 'Разархивировать zip архив',
  'Delete': 'Удалить',
  'Download': 'Скачать',
  'Copy link': 'Скопировать ссылку',
  'Done': 'Готово',
  'File': 'Файл',
  'Drop files to upload': 'Перетащите файлы для загрузки',
  'Close': 'Закрыть',
  'Select Folder': 'Выберите папку',
  'Users': 'Пользователи',
  'Files': 'Файлы',
  'Role': 'Роли',
  'Cancel': 'Отмена',
  'Paused': 'Приостановлено',
  'Confirm': 'Подтвердить',
  'Create': 'Создать',
  'User': 'Пользователь',
  'Admin': 'Админ',
  'Save': 'Сохранить',
  'Read': 'Чтение',
  'Write': 'Запись',
  'Upload': 'Загрузка',
  'Permissions': 'Разрешения',
  'Homedir': 'Домашняя папка',
  'Leave blank for no change': 'Оставьте поле пустым, чтобы оставить без изменений',
  'Are you sure you want to do this?': 'Вы уверены, что хотите выполнить это действие?',
  'Are you sure you want to allow access to everyone?': 'Вы уверены, что хотите предоставить доступ всем?',
  'Are you sure you want to stop all uploads?': 'Вы уверены, что хотите остановить все загрузки?',
  'Something went wrong': 'Что-то пошло не так',
  'Invalid directory': 'Недействительная папка',
  'This field is required': 'Это поле обязательное',
  'Username already taken': 'Имя пользователя уже занято',
  'User not found': 'Пользователь не найден',
  'Old password': 'Старый пароль',
  'New password': 'Новый пароль',
  'Wrong password': 'Неверный пароль',
  'Updated': 'Обновлено',
  'Deleted': 'Удалено',
  'Your file is ready': 'Ваш файл готов',
  'View': 'Просмотр',
  'Search': 'Поиск',
  'Download permission': 'Скачивание',
  'Guest': 'Гость',
  'Show hidden': 'Показать скрытое',
}

export default data

